export default "__VITE_ASSET__CyxOowPL__"